/**
 * This keeps the BAO push cart in sync with the BOGOS app when it adds and removes free gifts.
 */
(function () {
  function hasPushCart() {
    return document.querySelector('push-cart') != null;
  }

  function renderPushCartSections(state) {
    if (!state?.sections) return;
    const sections = window.BAO.sectionRenderer.pushCartSections
      .filter(s => s.section in state.sections)
      .map(s => ({ ...s, html: state.sections[s.section] }));
    window.BAO.sectionRenderer.renderMultiple(sections);
  }

  async function onBogosCartUpdated(event) {
    const { arrGiftsAdd = [], arrGiftsRemove = [] } = event.detail ?? {};
    if (!arrGiftsAdd.length && !arrGiftsRemove.length) return;
    if (!hasPushCart()) return;

    try {
      const state = await window.BAO.Cart.refreshCart();
      renderPushCartSections(state);
    } catch (err) {
      console.error('[bao] Failed to refresh push cart after BOGOS update:', err);
    }
  }

  document.addEventListener('fg-cart:auto-updated', onBogosCartUpdated);
})();
